<template>
  <div class="box">
    <div class="content flex-col">
      <div class="flex-row">
        <img class="label2" :src="emkt.MATERIAL_STATIC_FILE_BASE_URL + 'other/实物寄送流程.png'"/>
        <div class="layer3 flex-col">
            <span class="paragraph1">
              查看送样指南和信息表、收集样本
              <br>
              并填写实物信息表
            </span>
          <span class="paragraph1" style="margin-top: 45px;">
              寄送实物
              <br />
              并上传实物信息表
            </span>
          <span class="paragraph1" style="margin-top: 40px;">
              顺丰快捷下单
              <br />
              货到付款
              <br />
              填写快递单号
            </span>
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="footer-content">
        <div class="add-btn" @click="createSampleDeliverySheet"><span class="add-tag">寄送实物</span></div>
      </div>
    </div>
  </div>
</template>
<script>
  import EMKT from '../../emkt'
  import { mapGetters, mapMutations } from 'vuex'
  export default {
    name: 'MaterialSendProcess',
    computed: {
      ...mapGetters(['getOrderMaterialInfo'])
    },
    data () {
      return {
      }
    },
    methods: {
      ...mapMutations(['REASSEMBLE_ORDER_MATERIAL_INFO']),
      createSampleDeliverySheet () {
        this.REASSEMBLE_ORDER_MATERIAL_INFO(EMKT.reassembleOrderMaterialInfo(this.getOrderMaterialInfo))
        this.$router.push({
          name: 'AddSampleDeliverySheet',
          params: {fromType: EMKT.SAMPLE_DELIVERY_FORM_TYPE.fromAddSampleDelivery}
        })
      }
    }
  }
</script>
<style scoped>
  .box {
    overflow-y:scroll;
    overflow-x:hidden;
    height:100vh;
    position: relative;
    padding: 10px;
    padding-bottom: 0;
    background-color: #fafafa;
  }

  .content {
    height: 338px;
    border-radius: 10px;
    border: 0.5px solid rgba(239, 238, 243, 1);
    background-color: rgba(255, 255, 255, 1);
    align-self: center;
    width: 100%;
    justify-content: flex-end;
    align-items: flex-start;
    position: relative;
    padding: 0 0 30px 10px;
  }

  .layer3 {
    z-index: auto;
    width: 126px;
    height: 290px;
    margin: 16px 0 0 27px;
  }

  .paragraph1 {
    margin-top: 15px;
    width: 126px;
    height: 60px;
    display: block;
    overflow-wrap: break-word;
    color: rgba(66, 66, 66, 1);
    font-size: 14px;
    font-family: PingFangSC-Semibold;
    line-height: 20px;
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .label2 {
    margin-top: 30px;
    width: 45.9%;
    height: 270px;
  }

  .footer {
    position: fixed;
    bottom:0;
    left: 0;
    width: 100%;
    font-size: 14px;
    background-color: #fff;
  }

  .footer-content {
    display: flex;
    align-items: center;
    align-self: center;
    flex-direction: row;
    background-color: #ffffff;
    width: 100%;
    height: 58px;
    padding: 0px 10px;
  }

  .add-btn {
    width: 100%;
    height: 34px;
    border-radius: 17px;
    line-height: 20px;
    color: #fff;
    background-color: rgba(88, 120, 250, 1);
    justify-content: center;
    text-align: center;
    position: relative;
    margin-top: 8px;
    margin-bottom: 8px;
  }

  .add-tag {
    color: #ffffff;
    font-size: 14px;
    margin-left: -30px;
    white-space: nowrap;
    line-height: 20px;
    text-align: center;
    position: absolute;
    margin-top: 7px;
  }
</style>



// WEBPACK FOOTER //
// MaterialSendProcess.vue?0fab5f04